// src/hooks/usePayments.ts
import { useState, useEffect } from 'react';
import { getUserPayments } from '../api/userService';

interface Payment {
  id: string;
  payment_date: string;
  service_type: string;
  amount: number;
  currency: string;
  payment_method: string;
  comment: string;
}

const usePayments = () => {
  const [payments, setPayments] = useState<Payment[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPayments = async () => {
    setLoading(true);
    try {
      const data = await getUserPayments();
      // Ordenar pagos por fecha descendente
      const sortedPayments = data.sort(
        (a: Payment, b: Payment) => new Date(b.payment_date).getTime() - new Date(a.payment_date).getTime()
      );
      setPayments(sortedPayments);
    } catch (err) {
      setError('No se pudieron obtener los pagos.');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchPayments();
  }, []);

  return { payments, loading, error, fetchPayments };
};

export default usePayments;
